export default "__VITE_ASSET__DYZunN7R__"